import script from "./MilestoneBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./MilestoneBadge.vue?vue&type=script&setup=true&lang=js"

import "./MilestoneBadge.vue?vue&type=style&index=0&id=37b7966d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37b7966d"]])

export default __exports__